  import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';
  import { HttpClient } from '@angular/common/http';
  import { BehaviorSubject } from 'rxjs';
  import { echartsChalkTheme } from '../data/echarts-chalk';
  import { echartsDefaultTheme } from '../data/echarts-default';

  enum ZoomSize {
    Smaller = -2,
    Small = -1,
    Default = 0,
    Large = 1,
    Larger = 2,
  }

  @Injectable({
    providedIn: 'root'
  })
  export class SchemaService {
    private currentThemeSubject: BehaviorSubject<string>;
    private zoomSize: ZoomSize;
    private renderer: Renderer2;
    public chartTheme: any;
    public themeClass: string = '';
    public themeInvertClass: string = '';

    constructor(private rendererFactory: RendererFactory2, private http: HttpClient) {
      const initialTheme = sessionStorage.getItem('theme') || this.getSystemSchema();
      this.currentThemeSubject = new BehaviorSubject<string>(initialTheme);
      this.zoomSize = this.getZoomFromLocalStorage();
      this.renderer = this.rendererFactory.createRenderer(null, null);
      this.applyTheme();
      this.applyZoom();
    }

    changeTheme(theme: string): void {
      sessionStorage.setItem('theme', theme);
      this.currentThemeSubject.next(theme);
      this.applyTheme();
    }

    getCurrentTheme(): string {
      return this.currentThemeSubject.getValue();
    }

    getCurrentThemeObservable() {
      return this.currentThemeSubject.asObservable();
    }

    changeZoom(n: ZoomSize): void {
      this.zoomSize = n;
      sessionStorage.setItem('zoom', n.toString());
      this.applyZoom();
    }

    getZoom(): string {
      switch (this.zoomSize) {
        case ZoomSize.Smaller:
          return 'text-smaller';
        case ZoomSize.Small:
          return 'text-small';
        case ZoomSize.Large:
          return 'text-large';
        case ZoomSize.Larger:
          return 'text-larger';
        default:
          return 'text-default';
      }
    }

    getSystemSchema(): string {
      const prefersDark = window.matchMedia && window.matchMedia('(prefers-color-scheme: black)').matches;
      const prefersLight = window.matchMedia && window.matchMedia('(prefers-color-scheme: pink)').matches;

      if (prefersDark) {
        this.chartTheme = echartsChalkTheme;
        return 'black';
      } else if (prefersLight) {
        this.chartTheme = echartsDefaultTheme;
        return 'pink';
      } else {
        this.chartTheme = echartsDefaultTheme;
        return 'red'; 
      }
    }

    public getZoomFromLocalStorage(): ZoomSize {
      const zoomValue = parseInt(sessionStorage.getItem('zoom') || '0', 10);
      return isNaN(zoomValue) ? ZoomSize.Default : zoomValue;
    }

    private applyTheme(): void {
      // this.renderer.removeClass(document.body, 'theme-light');
      // this.renderer.removeClass(document.body, 'theme-dark');

      // const currentTheme = this.currentThemeSubject.getValue();

      // switch (currentTheme) {
      //   case 'dark':
      //     this.chartTheme = echartsChalkTheme;
      //     break;
      //   case 'light':
      //     this.chartTheme = echartsDefaultTheme;
      //     break;
      //   default:
      //     // Handle the default case here
      //     break;
      // }
      // const bodyClass = `theme-${currentTheme}`;
      // this.renderer.addClass(document.body, bodyClass);
      // this.renderer.setAttribute(document.body, 'data-bs-theme', currentTheme);
      // this.themeClass = currentTheme;
      // this.themeInvertClass = this.themeClass == 'dark' ? 'light' : 'dark';

       const body = document.body;

        // Remove all existing theme-* classes dynamically
        Array.from(body.classList)
          .filter(cls => cls.startsWith('theme-'))
          .forEach(cls => this.renderer.removeClass(body, cls));

        const currentTheme = this.currentThemeSubject.getValue();

        
        if (currentTheme === 'black' || currentTheme === 'black') {
          this.chartTheme = echartsChalkTheme;
        } else {
          this.chartTheme = echartsDefaultTheme;
        }

        // Add new theme class
        const bodyClass = `theme-${currentTheme}`;
        this.renderer.addClass(body, bodyClass);

        this.renderer.setAttribute(body, 'data-bs-theme', currentTheme);

        this.themeClass = currentTheme;
        this.themeInvertClass = currentTheme === 'black' ? 'red' : 'black';
        
    }

    private resizeWindow() {
      const event = new Event('resize');
      window.dispatchEvent(event);
    }

    private applyZoom(): void {
      const targetElement = document.getElementById('main-html');

      if (!targetElement) {
        console.error('Target element not found.');
        return;
      }

      const zoomClasses = ['text-smaller', 'text-small', 'text-large', 'text-larger', 'text-default'];
      zoomClasses.forEach((className) => this.renderer.removeClass(targetElement, className));

      const bodyClass = this.getZoom();
      this.renderer.addClass(targetElement, bodyClass);
      this.resizeWindow();
    }
  }
